export default __webpack_public_path__ + "static/media/faktur-pembelian.7d7e0d28.png";